import { create } from "zustand";
import { devtools } from "zustand/middleware";
/** Tracks which action-center action a legacy letter/form modal will complete on submit (old patients view). */
export var useActionCompletionStore = create()(devtools(function (set) {
  return {
    letter: null,
    form: null,
    setPending: function setPending(channel, link) {
      return set(function () {
        return channel === "letter" ? {
          letter: link
        } : {
          form: link
        };
      }, false, "setPending/".concat(channel));
    }
  };
}, {
  name: "ActionCompletionStore",
  enabled: typeof window !== "undefined" && process.env.NODE_ENV !== "production"
}));